"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Card = _interopRequireDefault(require("./Card"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var PopoverCard = (0, _styledComponents["default"])(_Card["default"]).attrs(function (props) {
  return {
    boxShadow: props.boxShadow || "card",
    borderRadius: props.borderRadius || "base",
    maxHeight: props.maxHeight || "90vh",
    overflow: props.overflow || "auto"
  };
}).withConfig({
  displayName: "PopoverCard",
  componentId: "sc-1khgb6c-0"
})(["border:1px solid ", ";"], function (props) {
  return props.theme.colors.border;
});
var _default = PopoverCard;
exports["default"] = _default;